import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M1.40011 23.0818C2.50011 9.73176 10.7301 10.5318 10.7301 10.5318C10.7301 10.5318 13.6101 4.64176 16.5801 3.03176C24.2101 -1.10824 42.9601 3.12176 45.4401 4.54176C47.9201 5.96176 53.9701 13.1818 53.9701 13.1818L52.2601 14.0618C52.2601 14.0618 55.8201 16.0518 56.4501 21.9918C57.5001 31.9018 52.3401 55.9518 52.3401 55.9518C52.3401 55.9518 53.8601 36.2418 48.5801 25.0518C47.2401 22.2218 44.7301 19.7718 44.7301 19.7718C44.7301 19.7718 38.3901 22.6318 30.3901 22.1518C24.8401 21.8218 14.7301 20.0018 14.7301 20.0018C14.7301 20.0018 10.2401 20.7218 7.67007 27.1018C3.74007 36.8518 5.57009 55.9418 5.57009 55.9418C5.57009 55.9418 0.580108 33.0218 1.40011 23.0818Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M22.46 21.4318C22.91 20.0618 23.7199 18.8318 24.6899 17.7518C25.6599 16.6618 26.8399 15.7618 28.1299 15.0618C28.4499 14.8818 28.7799 14.7218 29.1199 14.5918C29.4599 14.4618 29.79 14.2918 30.14 14.1918C30.85 14.0018 31.55 13.7718 32.28 13.7118C33.72 13.4818 35.19 13.6118 36.58 13.9418C35.17 14.2318 33.82 14.4318 32.53 14.8518C31.24 15.2218 30 15.7418 28.84 16.3818C26.48 17.6218 24.41 19.3718 22.46 21.4318Z"
        fill={outline}
      />
      <path
        d="M39.2602 17.6917C37.4902 18.2617 35.8102 18.8117 34.2202 19.5817C33.4202 19.9517 32.6802 20.4117 31.9502 20.9017C31.2302 21.4017 30.5902 22.0117 29.9102 22.6617C30.2302 21.7917 30.7602 20.9717 31.4502 20.3117C32.1302 19.6517 32.9302 19.1017 33.7802 18.6917C34.6402 18.2917 35.5402 17.9917 36.4602 17.8217C37.3802 17.6317 38.3302 17.5617 39.2602 17.6917Z"
        fill={outline}
      />
      <path
        d="M53.0201 18.0117C51.8601 17.7317 50.7201 17.4417 49.5501 17.2217C48.3901 16.9717 47.2401 16.7517 46.0701 16.5717C43.7401 16.2317 41.4001 15.9517 39.0701 15.9717C36.7401 15.9617 34.4101 16.2317 32.2401 16.9917C30.0601 17.7417 28.1601 19.2217 26.8601 21.2317C27.3201 20.1317 28.0401 19.1317 28.9001 18.2717C29.7801 17.4317 30.8301 16.7617 31.9501 16.2817C34.2001 15.2917 36.6701 14.9817 39.0701 14.9717C41.4901 14.9817 43.8801 15.2917 46.2101 15.8217C48.5501 16.3517 50.8501 17.0417 53.0201 18.0117Z"
        fill={outline}
      />
      <path
        d="M20.4502 20.6617C20.4502 20.6617 23.7102 11.2617 33.7902 10.3117C40.8402 9.6517 43.3202 13.1717 53.2202 11.6317"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M47.12 6.78174C47.12 6.78174 45.02 7.66174 31.69 7.88174C19.87 8.08174 18.74 19.7717 18.74 20.8717"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M14.7302 20.0018C14.7302 20.0018 7.87016 14.0618 2.16016 18.2418"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M11.4901 21.1017C11.4901 21.1017 5.39014 18.0217 1.39014 23.0817"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M8.07013 25.5017C8.07013 25.5017 1.78015 27.2617 1.40015 32.5517"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M44.8201 19.3916C44.8201 19.3916 53.0101 18.8416 56.6401 28.3616"
        stroke={outline}
        strokeMiterlimit="10"
      />
    </g>
  )
}
